import React from 'react';
import _ from 'lodash';
import {
  List,
  Datagrid,
  DateField,
  NumberField,
  ReferenceField,
  TextField,
  ShowButton,
  Filter,
  ReferenceInput,
  SelectArrayInput,
  SelectInput,
  SelectField,
  TextInput,
} from 'react-admin';
import FullNameField from '../General/FullNameField';
import { offeringCategory } from '../../helpers/mappings';
import { AccreditedField } from './CustomExternalOfferOrderFields';

import CustomExportButton from '../CustomExportButton';
import { modelFields, transformDataForExportFn } from './constants';

const OfferOrderFilter = props => (
  <Filter {...props}>
    <ReferenceInput
      label="Offer"
      source="offerId"
      reference="offerings"
      perPage={100}
      alwaysOn
      filter={{ isExternalOffer: 1 }}
    >
      <SelectInput
        optionText={choice => `${choice.name} (${_.values(offeringCategory).find(item => item.value === choice.category).label})`}
      />
    </ReferenceInput>
    <TextInput label="FirstName | LastName | Email" source="_OMNI_" alwaysOn style={{ width: 250 }} />
    <SelectArrayInput
      style={{ minWidth: 200 }}
      label="Order Status"
      source="endStatus"
      choices={[
       { id: '_null_', name: 'Pending' },
       { id: 'approved', name: 'Approved' },
       { id: 'rejected', name: 'Rejected' },
       { id: 'cancelled', name: 'Cancelled' },
     ]}
      alwaysOn
    />

  </Filter>
);


const ListActions = (props) => {
  const {
    currentSort, filterValues, total, resource,
  } = props;
  return (
    <CustomExportButton
      filter={filterValues}
      sort={currentSort}
      total={total}
      resource={resource}
      exportTitle="External Offer Orders - Export"
      modelFields={modelFields}
      transformFn={transformDataForExportFn}
    />
  );
};

export const STATUSES = [
  { id: null, name: 'Pending' },
  { id: 'cancelled', name: 'Cancelled' },
  { id: 'approved', name: 'Approved' },
  { id: 'rejected', name: 'Rejected' },
];


export default props => (
  <List
    {...props}
    title="Offer Orders"
    filters={<OfferOrderFilter />}
    bulkActionButtons={false}
    actions={<ListActions />}
  >
    <Datagrid>
      <DateField source="createdAt" />
      <TextField label="Name" source="offer.name" />
      <ReferenceField label="User" source="userId" reference="users" linkType="show" sortable={false}>
        <FullNameField />
      </ReferenceField>
      <ReferenceField label="Account" source="accountNumber" reference="accounts" linkType={false} sortable={false}>
        <TextField source="accountNumber" />
      </ReferenceField>
      <TextField source="deliverSecuritiesMode" />
      <AccreditedField source="accreditation" />
      <NumberField source="requestedTotalCurrencyAmt" options={{ style: 'currency', currency: 'USD' }} />
      <SelectField source="endStatus" choices={STATUSES} label="Order Status" />
      <ShowButton />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/components/ExternalOfferOrder/List.js